exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".office-editor-create-table{margin:8px;width:120px;height:150px;cursor:pointer}.office-editor-create-table table,.office-editor-create-table td{border:1px solid var(--gray-8);border-collapse:collapse}.office-editor-create-table td{width:12px;height:12px;padding:0}.office-editor-create-table td.highlighted-cell{background-color:var(--oe-table-dropdown-highlight)}.office-editor-create-table td:focus{outline:none}.office-editor-create-table .create-table-rows-columns{text-align:center;margin:10px 0}", ""]);

// exports
